<template>
  <div class="list-manage-container">
    <!-- 统计卡片 -->
    <div class="stats-cards">
      <div class="stat-card">
        <div class="stat-content">
          <div class="stat-label">黑名单总数</div>
          <div class="stat-value danger">{{ stats.blackListTotal || 0 }}</div>
          <div class="stat-trend" v-if="stats.blackListGrowth">
            <span :class="stats.blackListGrowth > 0 ? 'up' : 'down'">
              {{ stats.blackListGrowth > 0 ? '+' : '' }}{{ stats.blackListGrowth }}% 较昨日
            </span>
          </div>
        </div>
        <div class="stat-icon danger">
          <i class="el-icon-warning"></i>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-content">
          <div class="stat-label">白名单总数</div>
          <div class="stat-value success">{{ stats.whiteListTotal || 0 }}</div>
        </div>
        <div class="stat-icon success">
          <i class="el-icon-circle-check"></i>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-content">
          <div class="stat-label">今日命中次数</div>
          <div class="stat-value primary">{{ stats.todayHitCount || 0 }}</div>
          <div class="stat-trend" v-if="stats.hitCountGrowth">
            <span :class="stats.hitCountGrowth > 0 ? 'up' : 'down'">
              {{ stats.hitCountGrowth > 0 ? '+' : '' }}{{ stats.hitCountGrowth }}% 较昨日
            </span>
          </div>
        </div>
        <div class="stat-icon primary">
          <i class="el-icon-data-line"></i>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-content">
          <div class="stat-label">今日新增</div>
          <div class="stat-value info">{{ stats.todayAddCount || 0 }}</div>
        </div>
        <div class="stat-icon info add-btn" @click="handleAdd">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </div>

    <!-- Tab 切换 + 搜索 -->
    <div class="filter-bar">
      <div class="tab-switch">
        <el-button
          :type="activeTab === 'BLACK' ? 'danger' : 'default'"
          size="small"
          @click="switchTab('BLACK')">
          <i class="el-icon-warning"></i> 黑名单
        </el-button>
        <el-button
          :type="activeTab === 'WHITE' ? 'success' : 'default'"
          size="small"
          @click="switchTab('WHITE')">
          <i class="el-icon-circle-check"></i> 白名单
        </el-button>
      </div>
      <div class="search-area">
        <el-input
          v-model="searchForm.keyword"
          placeholder="搜索值或备注..."
          prefix-icon="el-icon-search"
          clearable
          style="width: 240px"
          @keyup.enter.native="search">
        </el-input>
        <el-select v-model="searchForm.targetType" placeholder="全部类型" clearable style="width: 120px; margin-left: 10px">
          <el-option label="手机号" :value="1"></el-option>
          <el-option label="IP地址" :value="2"></el-option>
          <el-option label="设备ID" :value="3"></el-option>
          <el-option label="卡号" :value="4"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" style="margin-left: 10px" @click="search">搜索</el-button>
      </div>
    </div>

    <!-- 数据表格 -->
    <v-tableEncapsulation
      :loading="loadingBtn.tableLoading"
      :columnData="columnData"
      :tableSize="pagination.size"
      :tableData="tableData"
      :tableTotal="pagination.total"
      :currentPage="pagination.current"
      @currentPage="handleCurrentChange"
      @sizeChange="handleSizeChange">
      <el-table-column slot="targetType" label="类型" align="center" width="100px">
        <template slot-scope="scope">
          <div class="type-cell">
            <i :class="getTypeIcon(scope.row.targetType)"></i>
            <span>{{ getTypeText(scope.row.targetType) }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column slot="hitCount" label="命中次数" align="center" width="100px">
        <template slot-scope="scope">
          <el-tag :type="getHitCountTagType(scope.row.hitCount)" effect="plain" size="small">
            {{ scope.row.hitCount }}次
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column slot="operate" label="操作" align="center" width="120px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDelete(scope.row)">
            <i class="el-icon-delete"></i> 删除
          </el-button>
        </template>
      </el-table-column>
    </v-tableEncapsulation>

    <!-- 新增弹窗 -->
    <el-dialog :title="activeTab === 'BLACK' ? '添加黑名单' : '添加白名单'" :visible.sync="addDialogVisible" width="500px">
      <el-form :model="addForm" :rules="addRules" ref="addFormRef" label-width="80px">
        <el-form-item label="类型" prop="targetType">
          <el-select v-model="addForm.targetType" placeholder="请选择类型" style="width: 100%">
            <el-option label="手机号" :value="1"></el-option>
            <el-option label="IP地址" :value="2"></el-option>
            <el-option label="设备ID" :value="3"></el-option>
            <el-option label="卡号" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="值" prop="targetValue">
          <el-input v-model="addForm.targetValue" :placeholder="getValuePlaceholder()"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="addForm.remark" placeholder="请输入备注信息" :rows="3"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="loadingBtn.addLoading" @click="submitAdd">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRiskListStats,
  queryRiskListPage,
  addRiskList,
  deleteRiskList
} from '@/api/risk/riskApi'

export default {
  name: 'listManage',

  data () {
    return {
      stats: {},
      activeTab: 'BLACK',
      searchForm: {
        keyword: '',
        targetType: ''
      },
      loadingBtn: {
        tableLoading: false,
        addLoading: false
      },
      columnData: [
        { type: 'index', label: '序号', width: '60px' },
        { slot: 'targetType' },
        { label: '值', prop: 'targetValue', width: '180px' },
        { label: '备注', prop: 'remark', minWidth: '150px' },
        { slot: 'hitCount' },
        { label: '创建时间', prop: 'createTime', width: '160px' },
        { slot: 'operate' }
      ],
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      addDialogVisible: false,
      addForm: {
        targetType: '',
        targetValue: '',
        remark: ''
      },
      addRules: {
        targetType: [{ required: true, message: '请选择类型', trigger: 'change' }],
        targetValue: [{ required: true, message: '请输入值', trigger: 'blur' }]
      }
    }
  },

  methods: {
    // 获取统计数据
    getStats () {
      getRiskListStats().then(({ data, code }) => {
        if (code === 0) {
          this.stats = data || {}
        }
      })
    },

    // 切换 Tab
    switchTab (tab) {
      this.activeTab = tab
      this.pagination.current = 1
      this.getTableData()
    },

    // 搜索
    search () {
      this.pagination.current = 1
      this.getTableData()
    },

    // 获取表格数据
    getTableData () {
      this.loadingBtn.tableLoading = true
      const params = {
        current: this.pagination.current,
        size: this.pagination.size,
        listType: this.activeTab === 'BLACK' ? 1 : 2,
        keyword: this.searchForm.keyword || undefined,
        targetType: this.searchForm.targetType || undefined
      }

      queryRiskListPage(params).then(({ records, total }) => {
        this.tableData = records || []
        this.pagination.total = total || 0
        this.loadingBtn.tableLoading = false
      }).catch(() => {
        this.loadingBtn.tableLoading = false
      })
    },

    // 页码变化
    handleCurrentChange (current) {
      this.pagination.current = current
      this.getTableData()
    },

    // 每页条数变化
    handleSizeChange (size) {
      this.pagination.size = size
      this.pagination.current = 1
      this.getTableData()
    },

    // 新增
    handleAdd () {
      this.addForm = { targetType: '', targetValue: '', remark: '' }
      this.addDialogVisible = true
      this.$nextTick(() => {
        this.$refs.addFormRef && this.$refs.addFormRef.clearValidate()
      })
    },

    // 提交新增
    submitAdd () {
      this.$refs.addFormRef.validate((valid) => {
        if (!valid) return
        this.loadingBtn.addLoading = true
        const data = {
          ...this.addForm,
          listType: this.activeTab === 'BLACK' ? 1 : 2
        }
        addRiskList(data).then(({ code }) => {
          if (code === 0) {
            this.$message.success('添加成功')
            this.addDialogVisible = false
            this.getStats()
            this.getTableData()
          }
          this.loadingBtn.addLoading = false
        }).catch(() => {
          this.loadingBtn.addLoading = false
        })
      })
    },

    // 删除
    handleDelete (row) {
      this.$confirm(`确认删除该${this.activeTab === 'BLACK' ? '黑' : '白'}名单记录？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteRiskList(row.id).then(({ code }) => {
          if (code === 0) {
            this.$message.success('删除成功')
            this.getStats()
            this.getTableData()
          }
        })
      }).catch(() => {})
    },

    // 获取类型图标
    getTypeIcon (type) {
      const iconMap = {
        1: 'el-icon-mobile-phone',
        2: 'el-icon-location-outline',
        3: 'el-icon-monitor',
        4: 'el-icon-bank-card'
      }
      return iconMap[type] || 'el-icon-document'
    },

    // 获取类型文本
    getTypeText (type) {
      const textMap = {
        1: '手机号',
        2: 'IP地址',
        3: '设备ID',
        4: '卡号'
      }
      return textMap[type] || '未知'
    },

    // 获取命中次数标签类型
    getHitCountTagType (count) {
      if (count >= 50) return 'danger'
      if (count >= 10) return 'warning'
      return 'info'
    },

    // 获取值输入提示
    getValuePlaceholder () {
      const placeholderMap = {
        1: '请输入手机号，如 138****1234',
        2: '请输入IP地址，如 192.168.1.***',
        3: '请输入设备ID',
        4: '请输入卡号，如 4111****1111'
      }
      return placeholderMap[this.addForm.targetType] || '请输入值'
    }
  },

  created () {
    this.getStats()
    this.getTableData()
  }
}
</script>

<style lang="scss" scoped>
.list-manage-container {
  padding: 20px;
  box-sizing: border-box;
  min-height: 100%;
  background: #fff;
}

.stats-cards {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;

  .stat-card {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #ebeef5;

    .stat-content {
      .stat-label {
        font-size: 14px;
        color: #909399;
        margin-bottom: 8px;
      }

      .stat-value {
        font-size: 28px;
        font-weight: 600;

        &.danger { color: #f56c6c; }
        &.success { color: #67c23a; }
        &.primary { color: #409eff; }
        &.info { color: #909399; }
      }

      .stat-trend {
        margin-top: 4px;
        font-size: 12px;

        .up { color: #f56c6c; }
        .down { color: #67c23a; }
      }
    }

    .stat-icon {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;

      &.danger { background: rgba(245, 108, 108, 0.1); color: #f56c6c; }
      &.success { background: rgba(103, 194, 58, 0.1); color: #67c23a; }
      &.primary { background: rgba(64, 158, 255, 0.1); color: #409eff; }
      &.info { background: rgba(144, 147, 153, 0.1); color: #909399; }

      &.add-btn {
        cursor: pointer;
        background: linear-gradient(135deg, #409eff, #66b1ff);
        color: #fff;
        transition: transform 0.2s;

        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }
}

.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .tab-switch {
    display: flex;
    gap: 10px;
  }

  .search-area {
    display: flex;
    align-items: center;
  }
}

.type-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  i {
    font-size: 16px;
    color: #606266;
  }
}
</style>
